import { LocalStorage, MultiStorage, SessionStorage } from "./BrowserStorage";

export interface IProduct {
   productID: number;
   name: string;
   regPrice: number;
   eachPrice: number;
}

interface IProductTable {
   version?: number;
   timestamp?: number;
   products?: Array<IProduct>
}

export class ProductRepository {
   private multiStore: MultiStorage;
   private table: IProductTable = {}
   constructor() {
      this.multiStore = new MultiStorage([
         new SessionStorage()
      ]);
   }
   private loadCache(): boolean {
      const data = this.multiStore.get('bu-p-cat');
      if (data) {
         const table = JSON.parse(data) as IProductTable;
         if (table.version === 1 && table.products && table.products.length > 0) {
            if (table.timestamp) {
               const age = (Date.now() - table.timestamp) / 1000.0;
               if (age < 5 * 60) {
                  this.table = table;
                  return true;
               }
            }
         }
      }
      return false;
   }
   private saveCache(): void {
      if (!this.table) return;
      const data = JSON.stringify(this.table);
      this.multiStore.set('bu-p-cat', data);
   }
   private async fetch(): Promise<void> {
      const response = await fetch("../app/api/productcatalog");
      const data = await response.json();
      const products = data as Array<IProduct>;
      this.table = {
         version: 1,
         timestamp: Date.now(),
         products: products
      };
   }
   public async load(): Promise<void> {
      const isCached = this.loadCache();
      if (!isCached) {
         await this.fetch();
         this.saveCache();
      }
   }

   public async getProduct(productId: number): Promise<IProduct | undefined> {
      if (!this.table) await this.load();
      return this.checkProduct(productId);
   }
   public checkProduct(productId: number): IProduct | undefined {
      const product = this.table?.products?.find((el) => {
         return el.productID === productId;
      });
      return product;
   }
}